import React, { useEffect, useRef, useState } from "react";

const SLIDES = [
  {
    src: require("../assets/images/landing-hero-desk.png"),
    alt: "QikTruck Business dashboard on a laptop in a Cape Town office",
  },
  {
    src: require("../assets/images/landing-hero-dispatch.png"),
    alt: "Ops manager with a tablet beside a branded QikTruck in a Johannesburg yard",
  },
  {
    src: require("../assets/images/landing-hero-trust.png"),
    alt: "QikTruck driver talking with a customer beside a loaded bakkie",
  },
  {
    src: require("../assets/images/landing-hero-trolley.png"),
    alt: "Crew rolling a fridge on an appliance trolley toward a QikTruck",
  },
  {
    src: require("../assets/images/landing-hero-sofa.png"),
    alt: "Crew moving a sofa on a furniture trolley to a branded bakkie",
  },
];

const INTERVAL_MS = 5600;

function prefersReducedMotion() {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export default function LandingHeroSlides() {
  const [index, setIndex] = useState(0);
  const reduceRef = useRef(true);

  useEffect(() => {
    reduceRef.current = prefersReducedMotion();
    if (reduceRef.current || SLIDES.length < 2) return undefined;

    const id = setInterval(() => {
      setIndex((current) => (current + 1) % SLIDES.length);
    }, INTERVAL_MS);

    return () => clearInterval(id);
  }, []);

  return (
    <div
      className="qt-hero-slides"
      aria-roledescription="carousel"
      aria-label="QikTruck Business in action"
    >
      {SLIDES.map((slide, i) => (
        <img
          key={slide.alt}
          src={slide.src}
          alt={i === index ? slide.alt : ""}
          className={i === index ? "is-active" : undefined}
        />
      ))}
      <div className="qt-hero-slides__dots" role="tablist" aria-label="Hero photos">
        {SLIDES.map((slide, i) => (
          <button
            key={slide.alt}
            type="button"
            role="tab"
            aria-selected={i === index}
            aria-label={`Photo ${i + 1}`}
            className={
              i === index
                ? "qt-hero-slides__dot is-active"
                : "qt-hero-slides__dot"
            }
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </div>
  );
}
